import languagesConfig from "./config/languages.json";

export const LANGUAGES = languagesConfig.languages;
export const DEFAULT_LANG = languagesConfig.defaultLang;

export const PORTFOLIO_SECTIONS = {
  "aboutMe": "about-me",
  "experience": "experience",
  "tools": "tools",
  "contact": "contact",
};

export const SITE_SECTIONS = {
  "portfolio": "portfolio",
  "blog": "blog",
  "fun": "fun",
};

export const CONTACT_MEANS = {
  "linkedin": "LINKEDIN_URL",
  "github": "GITHUB_URL",
  "email": "CONTACT_EMAIL",
};

export const DONATION_URL = "DONATION_URL";
